<template>
  <div class="bg" v-if="show">
    <div class="detail">
      <div class="header">
        <div class="title">
          {{detail.title}}
        </div>
        <img src="@assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="content">
        <div class="media">
          <div class="holder video" v-if="detail.type == 2">
            <img class="defaultPoster" src="@assets/img/common/infoplayMax.png" alt="default">
            <video :src="detail.url" controls controlsList="nodownload" contextmenu="none"></video>
          </div>
          <div class="holder audio" v-if="detail.type == 3">
            <div :class="{control: true, scrolling: scrollAudio}">
                <img src="@assets/img/common/infoplayMax.png" alt="cover">
            </div>
            <audio @play="onAudio('play')" @pause="onAudio('pause')" :src="detail.url" controls controlsList="nodownload"></audio>
          </div>
          <div class="holder image" v-if="detail.type == 1" :style="{'background-image': `url(${detail.url})`}"></div>
        </div>
        <div class="info">
          <div class="infoTitle">
            详情
          </div>
          <div class="infoDetail">
            <div class="basic">
              <div class="detailLine">
                <img class="icon" src="@assets/img/common/zz.svg" alt="reporter">
                <span>{{detail.username}}</span>
              </div>
              <div class="detailLine">
                <img class="icon" src="@assets/img/index/time.svg" alt="time">
                <span>{{detail.raw_add_time}}</span>
              </div>
            </div>
            <div class="extense">
              <div class="detailLine">
                <i class="icon">信源</i>
                <span>{{detail.source_info.ptitle}}</span>
              </div>
              <div class="detailLine">
                <i class="icon">频道</i>
                <span>{{detail.source_info.stitle}}</span>
              </div>
              <div class="detailLine">
                <i class="icon">上传来源</i>
                <span>{{detail.platform}}</span>
              </div>
            </div>
            <div class="property">
              <div class="detailLine">
                <i class="icon">格式</i>
                <span>{{detail.content.format || detail.content.type}}</span>
              </div>
              <div class="detailLine" v-if="detail.type == 2 || detail.type == 3">
                <i class="icon">时长</i>
                <span>{{detail.content.duration}}</span>
              </div>
              <div class="detailLine" v-if="detail.type == 3">
                <i class="icon">声道</i>
                <span>{{detail.content.track}}</span>
              </div>
              <div class="detailLine" v-if="detail.type == 2 || detail.type == 3">
                <i class="icon">码率</i>
                <span>{{detail.content.rate}}</span>
              </div>
              <div class="detailLine" v-if="detail.type == 2 || detail.type == 1">
                <i class="icon">大小</i>
                <span>{{detail.content.file_size || detail.content.size}}</span>
              </div>
              <div class="detailLine" v-if="detail.type == 1">
                <i class="icon">高度</i>
                <span>{{detail.content.resolution || detail.content.pixel}}</span>
              </div>
            </div>
          </div>
          <div class="infoFooter">
            <div class="btn" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type == 1" @click="downloadSource(detail)">
              下载
            </div>
            <div  v-click-outside="closeCard" class="btn" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type != 1" @click="toggleD(detail)">
              <span>
                下载
                <div ref="dOptions" class="dOptions" v-show="detail.showD">
                  <p :class="{'disableD': !detail.has_low_quality_download_role || detail.content.status != 1}" @click="downloadSource(detail, 0)">
                    <img src="@assets/img/common/800k.svg" alt="800k">
                    <i>800K码流</i>
                  </p>
                  <p :class="{'disableD': !detail.has_high_quality_download_role}" @click="downloadSource(detail, 1)">
                    <img src="@assets/img/common/HD.svg" alt="HD">
                    <i>原始码流</i>
                  </p>
                </div>
              </span>
            </div>
            <div class="convert" v-if="detail.type != 1 && detail.has_pickup_text_role">
              <div class="text" v-if="detail.text_status == 1" @click="convertWord(detail)">语音转文字</div>
              <div class="text" v-if="detail.text_status == 2"><img src="@assets/img/common/loading-g.svg" alt="loading" />转码中</div>
              <div class="text" v-if="detail.text_status == 3" @click="goWord(detail.idstring, detail.type)">查看文字</div>
              <div class="text fail" v-if="detail.text_status == 4" @click="convertWord(detail)" @mouseover.stop="hoverFailBtn(detail, true)" @mouseout.stop="hoverFailBtn(detail, false)">{{detail.hover?'语音转文字':'转码失败'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn push" @click="createReport()" v-show="detail.has_push_report">
          {{`推送${$_syscfg.report}`}}
        </div>
        <div class="btn push ml20" @click="pushPublish()" v-show="detail.has_publish">
         {{`推送${$_syscfg.publish}`}}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common';
import {apis} from '@common/config';
import vClickOutside from 'v-click-outside'

export default {
  name: 'materialDetail',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      detail: {},
      scrollAudio: false,
      show: false,
      callback: null
    }
  },
  methods: {
    closeCard() {
      console.log(123)
      this.detail.showD = false;
    },
    async pushPublish() {
      // 推送发布
      const id = this.detail.id
      const t = 'file'
      const type = await this.$pageType('publish')
      if (!type) return

      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      }

      common.myFetch(apis.publish_pushPublish, info).then((r) => {
        if (r) {
          const url = `/editPublish?d=${r.id}`

          common.jump(url, true)
        }
      })
    },
    toggleD(i) {
      console.log(i)
      // 切换下载码率列表
      if(i.showD){
        this.$nextTick(() => {
          this.$set(i, 'showD', false)
          this.$refs.dOptions.style.display = 'none'
          console.log(i.showD)
        })
        
        // this.detail.showD = false;

      }else{
        this.$nextTick(() => {
          this.$set(i, 'showD', true)
          this.$refs.dOptions.style.display = 'block'
          console.log(i.showD)
        })
        // this.detail.showD = true;
      }
      // this.$set(i, 'showD', !i.showD)
    },
    downloadSource(source, type) {
      console.log(source)
      if (type === 0) {
        if (!this.detail.has_low_quality_download_role) {
          this.$toast('无下载权限')
          return
        } else {
          if (source.content.status != 1) {
            this.$toast('转码尚未完成')
            return
          }
        }
      } else if (type === 1) {
        if (!this.detail.has_high_quality_download_role) {
          this.$toast('无下载权限')
          return
        }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0,
        // subject_type: 0,
        // subject_id: this.$route.query.d
      }
      const url = apis.File_download
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)

      common.exportRes(url, params, 1)
    },
    onAudio(action) {
      // 监听audio播放状态
      if (action === 'play') {
        this.scrollAudio = true
      } else {
        this.scrollAudio = false
      }
    },
    open(callback) {
      // 打开窗口
      this.callback = callback

      this.show = true
    },
    hide() {
      // 隐藏窗口
      this.show = false
      this.callback = null
    },
    close() {
      // 关闭事件
      if(this.callback){
        this.callback()
      }
      
      this.clearDetail()

      this.hide()
    },
    clearDetail() {
      // 清除数据
      this.detail = {}
    },
    getDetail(id) {
      // 获取详情接口
      const info = {
        id: id
      }

      return common.myFetch(apis.file_detail, info)
      .then(r => {
        if (r) {
          this.detail = r.detail
        }

        return r
      })
    },
    goWord(idstring, type) {
      let url = `/videotoword?d=${idstring}`
      if (type == 3) {
        url = `/audiotoword?d=${idstring}`
      }

      common.jump(url, true)
    },
    convertWord(f) {
      // 音视频转文字
      console.log(123, f)
      if ((!f.content || f.content.status != 1) && f.type != 3) {
        this.$toast('转码中，暂时无法转文字')
        return
      }

      const info = {
        idstring: f.idstring
      }

      common.myFetch(apis.File_convert, info)
      .then((r) => {
        if (r) {
          this.$toast(r)

          this.$set(f, 'text_status', 2)
        }
      })
    },
    hoverFailBtn(item, status) {
      // 转码失败按钮鼠标事件
      this.$set(item, 'hover', status)
    },
    getTranstext(r) {
      // 获取转文字状态
      console.log(r)
      this.$toast('转文字完成')
      this.getDetail(r.content.content.id)
    },
    async createReport() {
      // 根据类型推送报道
      const type = await this.$pageType()
      if (!type) return

      const info = {
        id: this.detail.id,
        type: type
      }
      const newWindow = window.open()

      common.myFetch(apis.file_toReport, info)
      .then((r) => {
        if (r) {
          const reportId = r.report_id

          newWindow.location.href = `${window.location.origin}/creatReport?push=${this.detail.id}&t=${type}&d=${reportId}`
        }
      })
    }
  },
  mounted() {
    common.handleSocket(this.getTranstext, 'pickuptext')
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

  .bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1099;
    .detail {
      width: 1040px;
      height: 578px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      background-color: #EBF0F5;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 20px 30px;
        .title {
          flex: 1;
          min-height: 24px;
          font-weight: 24px;
          font-weight: bold;
          color: @dark;
          word-break: break-all;
        }
        .close {
          margin-left: 6px;
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
      .content {
        flex: 1;
        display: flex;
        padding: 0 30px;
        margin-bottom: 20px;
        // overflow: hidden;
        .media {
          flex: 1;
          height: 100%;
          margin-right: 20px;
          background-color: #f9f9f9;
          overflow: hidden;
          .holder {
            width: 100%;
            height: 100%;
            position: relative;
            .defaultPoster {
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              // width: 100%;
              // height: 100%;
              z-index: 1;
            }
            video {
              position: absolute;
              width: 100%;
              height: 100%;
              z-index: 2;
            }
            audio {
              width: 100%;
            }
          }
          .image {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
          .audio {
            padding: 30px;
            .control{
                width: 220px;
                height: 220px;
                margin: 40px auto 30px;
                animation-name: identifier;
                animation-duration: 3s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
                animation-play-state: paused;
                img{
                    width: 100%;

                }
            }
            .scrolling {
              animation-play-state: running;
            }
          }
        }
        .info {
          .boxOuter;
          width: 240px;
          height: 100%;
          display: flex;
          flex-direction: column;
          // overflow: hidden;
          max-height: 414px;
          .infoTitle {
            .boxOuter;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-weight: bold;
            padding: 0 14px;
          }
          .infoDetail {
            flex: 1;
            overflow-y: hidden;
            padding-bottom: 10px;
            // margin: 0 4px 0 0;
            &:hover {
              overflow-y: auto;
            }
            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background: #ddd;
                border-radius: 4px;
            }
            .detailLine {
              height: 20px;
              display: flex;
              align-items: center;
              margin: 10px 0;
              .icon {
                margin-right: 10px;
                font-size: 13px;
                color: @dateColor;
              }
              span {
                font-size: 14px;
                color: @sub;
              }
            }
            .basic {
              margin: 0 20px;
              padding: 4px 0;
              border-bottom: 1px solid #d8d8d8;
              span {
                color: @dateColor;
              }
            }
            .extense {
              padding: 2px 20px;
            }
            .property {
              background-color: fade(@dateColor, 15);
              padding: 2px 20px;
            }
          }
          .infoFooter {
            height: 58px;
            padding: 12px 20px 16px;
            display: flex;
            .dOptions {
              position: absolute;
              width: 135px;
              height: 80px;
              left: 0;
              margin-top: 10px;
              border-radius: 4px;
              overflow: hidden;
              background-color: rgba(5, 15, 15, 0.8);
              z-index: 10000;
              p {
                height: 40px;
                background-color: rgba(5, 15, 15, 0.8);
                display: flex;
                padding: 0 20px;
                cursor: pointer;
                font-size: 13px;
                color: #fff;
                align-items: center;
                i {
                  margin-left: 10px;
                }
              }
              .disableD {
                cursor: not-allowed;
                background-color: rgba(255, 255, 255, .1);
              }
            }
            .btn {
              flex: 1;
              height: 30px;
              line-height: 30px;
              border-radius: 4px;
              background-color: @green;
              color: #fff;
              font-size: 14px;
              text-align: center;
              cursor: pointer;
              position: relative;
              &:hover {
                .btnHover;
              }
              &:active {
                .btnActive;
              }
            }
            .convert {
              margin-left: 30px;
              color: @green;
              background-color: #f9f9f9;
              // border: 1px solid @green;
              flex: 1;
              position: relative;
              cursor: pointer;
              &:hover {
                .btnHover;
              }
              &:active {
                .btnActive;
              }
              .text {
                width: 100%;
                height: 30px;
                border-radius: 4px;
                border: 1px solid @green;
                position: absolute;
                z-index: 9;
                font-size: 14px;
                color: @green;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  height: 100%;
                  width: auto;
                }
              }
            }
            .convert:first-child {
              margin-left: 0;
            }
          }
        }
      }
      .footer {
        .boxOuter;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          width: 120px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          background-color: @green;
          border-radius: 100px;
          cursor: pointer;
          &:hover {
            .btnHover;
          }
          &:active {
            .btnActive;
          }
        }
        .ml20 {
          margin-left: 20px;
        }
      }
    }
  }
</style>
